import { render, staticRenderFns } from "./ModalVisualizarGuia.vue?vue&type=template&id=30ca00f2&scoped=true&"
import script from "./ModalVisualizarGuia.vue?vue&type=script&lang=js&"
export * from "./ModalVisualizarGuia.vue?vue&type=script&lang=js&"
import style0 from "./ModalVisualizarGuia.vue?vue&type=style&index=0&id=30ca00f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca00f2",
  null
  
)

export default component.exports